<template>
  <div>
    <h1>Uh-Oh!</h1>
    <h3>
      Parece que está experimentando algunos problemas de red, por favor haga
      clic en el botón e inténtelo de nuevo.
    </h3>

    <button @click="$router.back()">Volver a la página anterior</button>

    <router-link :to="{ name: 'visit-list' }">
      Volver a la página principal
    </router-link>
  </div>
</template>
<script>
export default {
  name: "NetworkIssue",
};
</script>
